import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { fieldFilteringSchemaObject } from '../fieldSchema';
import { FieldListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'FIELD'

export function FieldFiltering(props) {
    const [title, setTitle] = useState("Field");
    const [groups, setGroups] = useState([]);
    const [estate, setEstate] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [fieldFilteringData, setFieldFilteringData] = useState([]);
    const [fieldFiltering, setFieldFiltering] = useState({
        groupID: '0',
        estateID: '0',
        collectionPointCategoryID: '0',
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(fieldFilteringSchemaObject).options({ allowUnknown: true });


    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstateForDropdown()
        )
    }, [fieldFiltering.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointCategoryForDropDown()
        )
        handleSearch();
    }, [fieldFiltering.estateID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFIELDLISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITFIELD');

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setFieldFiltering({
            ...fieldFiltering,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropdown()
        )
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getEstateForDropdown() {
        const estate = await services.GetAllEstatesByGroupID(fieldFiltering.groupID);
        setEstate(estate);

    }

    async function getCollectionPointCategoryForDropDown() {
        const collectionPoint = await services.getAllDivisionsByEstateID(fieldFiltering.estateID);
        setCollectionPoint(collectionPoint);
    }

    function handleGroupDropdown(target) {
        validateInputs(target);

        setFieldFiltering({
            ...fieldFiltering,
            groupID: target.value,
            estateID: '0',
            collectionPointCategoryID: '0'
        });
    }

    function handleOperationEntityDropdown(target) {
        validateInputs(target);

        setFieldFiltering({
            ...fieldFiltering,
            estateID: target.value,
            collectionPointCategoryID: '0'
        });
    }

    function handleCollectionPointDropdown(target) {
        validateInputs(target);

        setFieldFiltering({
            ...fieldFiltering,
            collectionPointCategoryID: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, fieldFilteringSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {
        if (e !== undefined) {
            const errorMessages = validate(schema, fieldFiltering);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.getFieldFilterData(fieldFiltering);
        setFieldFilteringData(response);
        
    }

    async function editFieldFiltering(data) {
        props.history.push({
            pathname: 'field/addEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setFieldFiltering({
            ...fieldFiltering,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            estateID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointCategoryID: '0',
        });
        setFieldFilteringData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="field/addEdit"
                                    buttonText="Add Estate"
                                />
                            </div>
                            <hr />

                            <form disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={fieldFiltering.groupID}
                                            onChange={(e) => handleGroupDropdown(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="estateID"
                                            value={fieldFiltering.estateID}
                                            onChange={(e) => handleOperationEntityDropdown(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estate)}
                                        </Select>
                                        {errors["estateID"] && <FormHelperText error>{errors["estateID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointCategoryID">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointCategoryID"
                                            id="collectionPointCategoryID"
                                            name="collectionPointCategoryID"
                                            value={fieldFiltering.collectionPointCategoryID}
                                            onChange={(e) => handleCollectionPointDropdown(e.target)}>
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointCategoryID"] && <FormHelperText error>{errors["collectionPointCategoryID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                                <FieldListing fieldFilteringData={fieldFilteringData} handleClick={editFieldFiltering} />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}